import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Card} from "react-bootstrap";
import success from "../../../../../../../_metronic/assets/lottie/96237-success.json";
import Lottie from "lottie-react";
import {useIntl} from "react-intl";
import {useAppDispatch} from "../../../../../../infrastructure/hooks/reduxHooks";
import {subscriptionActions} from "../../subscriptionActions";
import {useSelector} from "react-redux";
import {organisationSelectors} from "../../../../organisationSelectors";
import * as urls from "../../../../../../infrastructure/variables/urls";


export const Success = () => {

    const intl = useIntl()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const organisationId = useSelector(organisationSelectors.getSelectedOrganisationId())

    const [showSuccess, setShowSuccess] = useState(true)
    const [showError, setShowError] = useState(false)
    const [searchParams] = useSearchParams();

    useEffect(() => {

        setTimeout(() => {
            window.location.href = `/organisation/${organisationId}/subscription`
        }, 7000)

    }, [])

    return (
        <>
            <Card>
                <Card.Body>
                    <>
                        {
                            (showSuccess || showError) &&
                            <div>
                                <div className="w-200px mx-auto">
                                    <Lottie animationData={success} loop={false}/>
                                </div>
                            </div>
                        }
                        {showSuccess &&
                            <>
                                <div className="text-center fs-4">
                                    {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.MESSAGE.SUBSCRIPTION_SUCCEED"})}
                                </div>
                            </>
                        }
                        {showError &&
                            <div className="text-center fs-3 text-danger mt-6 mb-6 fw-bold">
                                {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.MESSAGE.SUBSCRIPTION_FAILED"})}
                            </div>
                        }
                    </>
                </Card.Body>
            </Card>
        </>
    )
}